import React from 'react';
import './error.css';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className='container error_container'>
        <div className='row'>
            <div className='col-12'>
                <center>
                    <h1>Error 404: Página no encontrada</h1>
                    <p>Lo siento, la página que está buscando no existe.</p>
                    <a className='btn_error' href='https://policiaindustrialbancaria.hidalgo.gob.mx/'  >INICIO</a>
                </center>
            </div>
        </div>
    </div>
  )
}

export default Error404